import React, { useContext, useEffect, useRef, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import { PaginationComponent } from "../../components";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import PageLayout from "../../layouts/PageLayout";
import { listSims } from "../../APIs/SimsRequests";
import SimsTableComponent from "../../components/tables/SimsTableComponent";
import { listPendingSimsCount } from "../../APIs/SupervisorRequests";

export default function SimsListPage() {

    const { t } = useContext(TranslatorContext);
    const [sims, setSims] = useState([]);
    const [pagination, setPagination] = useState({});
    const [perPage, setPerPage] = useState(10);
    const [searchFilter, setSearchFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');


    const hasViewPendingSimsCountPermission = localStorage.getItem('permissions').includes('view pending sims count');
    const [pendingSimsCount, setPendingSimsCount] = useState(0);
    const [approvedTodayCount, setApprovedTodayCount] = useState(0);

    const searchFilterRef = useRef();
    const perPageRef = useRef();

    const listPendingSimsCountAction = () => {
            listPendingSimsCount().then((res) => {
                setPendingSimsCount(res.data.data.count);
                setApprovedTodayCount(res.data.data.approved_today_count);
            }).catch((error) => {
                console.log(error);
            });
        }
    useEffect(() => {
        searchFilterRef.current = searchFilter;
        perPageRef.current = perPage;

        if(localStorage.getItem('permissions').includes('view pending sims count')) {
            listPendingSimsCountAction();
        }
      }, [perPage,searchFilter]);
    
      useEffect(() => {
        listSimsFunction();
      }, [perPage, searchFilter, statusFilter]);
    
      useEffect(() => {
        const intervalId = setInterval(() => {
          listSimsFunction(1,perPageRef.current,searchFilterRef.current);
        }, 10000);
        return () => clearInterval(intervalId); 
      });
    const listSimsFunction = (page=1) => {
        listSims(page,perPage,searchFilter,'',statusFilter).then((res) => {
            setSims(res.data.data);
            setPagination(res.data.pagination);
        }).catch((error) => {

        });
    }

    const thead = [t("number"), t("serial"), t("customer_id"),t("customer_name"),t('puk'), t("created"), t("action")];

    const handlePageClick = (selected) => {
        listSimsFunction(selected.selected + 1);
    }
    
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('sims_list')}</h3>
                            {
                                hasViewPendingSimsCountPermission ? 
                                <>
                                    <h4>{t('pending_sims')}: {pendingSimsCount}</h4>
                                    <h4>{t('responded_today_count')}: {approvedTodayCount}</h4>
                                </>
                                 : ''
                            }
                           
                            {/* <ButtonComponent  className="btn btn-primary m-2" onClick={redirectToCreatePage}>{ t('Create New') }</ButtonComponent> */}
                        </div>
                    </div>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        
                        <Row xs={1} sm={2} xl={4}>
                            <Col>
                                <LabelFieldComponent
                                    label={t('show_by')}
                                    option={["10", "20", "50", "100"] }
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange= {(e)=>{
                                        setPerPage(e.target.value);
                                    }}
                                />
                            </Col>
                            
                            
                            <Col>
                                <LabelFieldComponent
                                    type="search"
                                    label={t('search_by')}
                                    placeholder={''}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange={(e) => {
                                            setSearchFilter(e.target.value);
                                    }}
                                />
                            </Col>

                            <Col>
                                <LabelFieldComponent
                                    label={t('status')}
                                    option={["All","pending", "approved", "rejected"] }
                                    value={statusFilter}
                                    placeholder={t('select_status')}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange= {(e)=>{
                                        setStatusFilter(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <SimsTableComponent
                            thead={ thead }
                            tbody={ sims }
                            refreshPage={ listSimsFunction }
                        />
                        <PaginationComponent pagination={pagination} handlePageClick={handlePageClick}/>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}